import { createTheme } from '@mui/material';

import { palette } from './base/palette';
import { typography } from './base/typography';
import { HarborTheme } from './types';

const recoveryCollectiveTheme: HarborTheme = createTheme({
  palette: {
    ...palette,
    background: {
      default:
        'linear-gradient(170deg, #3C0040 0%, #3F3B6E 33%, #478E94 66%, #B2D0D0 100%)',
    },
  },
  typography,
});

export { recoveryCollectiveTheme };
